import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { TopBar } from "@/components/layout/TopBar";
import Login from "@/pages/Login";
import Episodes from "@/pages/Episodes";
import NewEpisode from "@/pages/NewEpisode";
import BatchEpisodes from "@/pages/BatchEpisodes";
import { UpdateBanner } from "@/components/UpdateBanner";
import EpisodeDetail from "@/pages/EpisodeDetail";
import MediaLibrary from "@/pages/MediaLibrary";
import JobsQueue from "@/pages/JobsQueue";
import QCConsole from "@/pages/QCConsole";
import BenchmarkLab from "@/pages/BenchmarkLab";
import Engines from "@/pages/Engines";
import Team from "@/pages/Team";
import Costs from "@/pages/Costs";

const Protected = ({ admin }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-500 text-sm font-mono">Checking session…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (admin && user.role !== "admin") return <Navigate to="/episodes" replace />;
  return (
    <>
      <UpdateBanner />
      <TopBar />
      <main className="px-4 md:px-6 py-5 max-w-[1600px] mx-auto"><Outlet /></main>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected />}>
              <Route path="/" element={<Navigate to="/episodes" replace />} />
              <Route path="/episodes" element={<Episodes />} />
              <Route path="/episodes/new" element={<NewEpisode />} />
              <Route path="/episodes/batch" element={<BatchEpisodes />} />
              <Route path="/episodes/:episodeId" element={<EpisodeDetail />} />
              <Route path="/qc" element={<QCConsole />} />
              <Route path="/qc/:jobId" element={<QCConsole />} />
            </Route>
            <Route element={<Protected admin />}>
              <Route path="/media" element={<MediaLibrary />} />
              <Route path="/jobs" element={<JobsQueue />} />
              <Route path="/benchmark" element={<BenchmarkLab />} />
              <Route path="/benchmark/:benchmarkId" element={<BenchmarkLab />} />
              <Route path="/engines" element={<Engines />} />
              <Route path="/costs" element={<Costs />} />
              <Route path="/team" element={<Team />} />
            </Route>
          </Routes>
          <Toaster theme="dark" position="bottom-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
